import React, { useState } from "react";
import Letter from "../ui/Letter";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPlay, updatePlay } from "../store/play";
import TaskLoader from "../components/hoc/taskLoader";
import Complete from "../components/Complete";
import { getStartByPlayId } from "../store/start";
import { getCurrentGroup, updateGroup } from "../store/groups";
import { createPayment } from "../store/payment";
import { getCurrentUserData } from "../store/users";
import configFile from "../config.js";
import { formatTime } from "../utils/formatTime";
import { useI18n } from "../i18n/LanguageContext";

function Go() {
  const dispatch = useDispatch();
  const { t } = useI18n();
  const { country } = useParams();
  const currentUser = useSelector(getCurrentUserData());
  const group = useSelector(getCurrentGroup());
  const play = useSelector(getPlay(group && group.playId));
  const start = useSelector(getStartByPlayId(play && play._id));
  const navigate = useNavigate();
  const [payToAdmin] = useState({
    payer: currentUser._id,
    sum: -15000,
    missionId: group.missionId,
    teamId: group._id,
    writeOff: true,
  });

  function gameOver(play) {
    dispatch(createPayment(payToAdmin));
    dispatch(updatePlay(play));
    dispatch(updateGroup({ ...group, missionId: null, playId: null }));
  }

  const handleCheck = () => {
    // списание средств по завершении игры
    gameOver(play);
    navigate(`/${country}/user/${currentUser._id}`);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const timePlay =
    Date.parse(play?.created_at) + Number(configFile.REACT_APP_PLAY_TIME);

  const timeNow = Date.now();

  return (
    <>
      <TaskLoader>
        <div className="flex flex-col px-3">
          {start ? (
            <Complete start={start} play={play} />
          ) : (
            <>
              <div className="block text-center">
                <div className="mt-10 mb-6 font-medium text-lg">
                  {t("go.hello")}
                </div>
                <div className="mt-10">{t("go.cityBounds")}</div>
                <div className="mb-20 sm:px-40">
                  <div className="my-4">{t("go.windows")}</div>
                </div>
                <div className="items-center align-middle">
                  <div>
                    <div className="flex flex-row justify-center py-10">
                      {t("go.missionLeft")}
                      <p className="px-2">{formatTime(timePlay)}</p>{" "}
                      {t("complete.hours")}
                    </div>

                    <div className="flex justify-center">
                      {play && !play.endPlay ? (
                        play.secret
                          .split("")
                          .map((elem, index) => (
                            <Letter
                              key={index}
                              letter={elem.toString()}
                              number={index}
                              taskId={play.tasks[index]}
                              start={start}
                            />
                          ))
                      ) : timeNow > timePlay ? (
                        <div className="text-xl font-bold">{t("go.timeUp")}</div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className="flex justify-center mt-10">
                      <h1>{t("go.anyOrder")}</h1>
                    </div>
                  </div>
                </div>
              </div>
              {play && play.endPlay && (
                <div className="flex justify-center my-10">
                  <button
                    className="bg-green-400 text-gray-700 block px-10 py-2 text-sm hover:bg-green-500 border-spacing-2 border-orange-400 border-2 hover:border-green-300 rounded-md"
                    onClick={handleCheck}
                  >
                    {t("go.result")}
                  </button>
                </div>
              )}
              <div className="flex justify-end my-10">
                <button
                  className="bg-green-400 text-gray-700 block px-10 py-2 text-sm hover:bg-green-500 border-spacing-2 border-orange-400 border-2 hover:border-green-300 rounded-md"
                  onClick={handleGoBack}
                >
                  {t("common.back")}
                </button>
              </div>
              <div className="block mt-20 justify-between">
                <div className="font-medium">{t("go.hints")}</div>
                <ul>
                  {Array.from({ length: 10 }, (_, index) => (
                    <li key={index}>{t(`go.h${index + 1}`)}</li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </div>
      </TaskLoader>
    </>
  );
}

export default Go;
